import { Dispatch } from "react-redux";
import { AuthActionCreators, IApplicationState } from "../";
import { ActionTypes } from ".";
import { ICenter, ILogisticsProvider, IContact, IListItem, ITransportType, ICenterToCenterDistance } from "../../models";
import { IDutyOfficer } from "../../models/duty-officer";

export interface ISwapLookupDataResponse {
    data: {
        success: boolean,
        results: {
            clusterStatusList: IListItem[],
            chainStatusList: IListItem[],
            staffList: IContact[],
            logisticsProviderList: ILogisticsProvider[],
            pairStatusList: IListItem[],
            centerList: ICenter[],
            transportTypeList: ITransportType[],
            swapTypeList: IListItem[],
            distanceBetweenCenters: ICenterToCenterDistance[]
        }
    }
}

export interface ISwapLookupDataCenterListResponse {
    data: {
        success: boolean,
        results: ICenter[]
    }
}

export interface ILogisticsLookupDataResponse {
    data: {
        success: boolean,
        results: {
            logisticsProviderList: ILogisticsProvider[],
            transportTypeList: ITransportType[],
            staffList: IContact[],
            distanceBetweenCenters: ICenterToCenterDistance[]
        }
    }
}

export interface IDutyOfficerResponse {
    data: {
        success: boolean;
        result: IDutyOfficer;
    };
}

export const ActionCreatorsLookupData = {
    getLookupData: () => (dispatch: Dispatch<IApplicationState>): Promise<ISwapLookupDataResponse> => {
        var options = {
            url: __API__ + "/swap/lookup-data"
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: ISwapLookupDataResponse) => {
            var { success, results } = response.data;

            if (success) {
                dispatch(ActionCreatorsLookupData.setClusterStatusList(results.clusterStatusList));
                dispatch(ActionCreatorsLookupData.setChainStatusList(results.chainStatusList));
                dispatch(ActionCreatorsLookupData.setStaffList(results.staffList));
                dispatch(ActionCreatorsLookupData.setLogisticsProviders(results.logisticsProviderList));
                dispatch(ActionCreatorsLookupData.setPairStatusList(results.pairStatusList));
                //AS - Removed -> causing issues merging empty list into REDUX store
                //dispatch(ActionCreatorsLookupData.setCenterList(results.centerList));
                dispatch(ActionCreatorsLookupData.setTransportTypeList(results.transportTypeList));
                dispatch(ActionCreatorsLookupData.setSwapTypeList(results.swapTypeList));
                dispatch(ActionCreatorsLookupData.setDistanceBetweenCenters(results.distanceBetweenCenters));
            }

            return Promise.resolve(response);
        });
    },
    getCenterList: () => (dispatch: Dispatch<IApplicationState>): Promise<ISwapLookupDataCenterListResponse> => {
        let options = {
            url: __API__ + '/swap/center-list'
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: ISwapLookupDataCenterListResponse) => {
            var { success, results } = response.data;

            if (success) {
                dispatch(ActionCreatorsLookupData.setCenterList(results));
            }

            return Promise.resolve(response);
        });
    },
    getLogisticsLookupData: () => (dispatch: Dispatch<IApplicationState>): Promise<ILogisticsLookupDataResponse> => {
        var options = {
            url: __API__ + "/logistics/lookup-data"
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: ILogisticsLookupDataResponse) => {
            var { success, results } = response.data;

            if (success) {
                dispatch(ActionCreatorsLookupData.setLogisticsProviders(results.logisticsProviderList));
                dispatch(ActionCreatorsLookupData.setTransportTypeList(results.transportTypeList));
                dispatch(ActionCreatorsLookupData.setStaffList(results.staffList));
                dispatch(ActionCreatorsLookupData.setDistanceBetweenCenters(results.distanceBetweenCenters));
            }

            return Promise.resolve(response);
        });
    },
    getCurrentDutyOfficer: () => async (dispatch: Dispatch<IApplicationState>): Promise<IDutyOfficerResponse> => {
        var options = {
            url: __API__ + "/swap/current-duty-officer"
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    setClusterStatusList: (list: IListItem[]) => {
        return {
            type: ActionTypes.SET_CLUSTERSTATUSLIST,
            list
        };
    },
    setChainStatusList: (list: IListItem[]) => {
        return {
            type: ActionTypes.SET_CHAINSTATUSLIST,
            list
        };
    },
    setStaffList: (list: IContact[]) => {
        return {
            type: ActionTypes.SET_STAFFLIST,
            list
        };
    },
    setLogisticsProviders: (list: ILogisticsProvider[]) => {
        return {
            type: ActionTypes.SET_LOGISTICSPROVIDERS,
            list
        };
    },
    setPairStatusList: (list: IListItem[]) => {
        return {
            type: ActionTypes.SET_PAIRSTATUSLIST,
            list
        };
    },
    setCenterList: (list: ICenter[]) => {
        return {
            type: ActionTypes.SET_CENTERLIST,
            list
        };
    },
    setTransportTypeList: (list: ITransportType[]) => {
        return {
            type: ActionTypes.SET_TRANSPORTTYPELIST,
            list
        };
    },
    setSwapTypeList: (list: IListItem[]) => {
        return {
            type: ActionTypes.SET_SWAPTYPELIST,
            list
        };
    },
    setDistanceBetweenCenters: (list: ICenterToCenterDistance[]) => {
        return {
            type: ActionTypes.SET_DISTANCE_BETWEEN_CENTERS,
            list
        };
    }
}